
import Vue from "vue";
import { mapActions } from "vuex";

import Spinner from "@/components/Spinner.vue";

export default Vue.extend({
  name: "AuthLoginRedirectPage",
  components: { Spinner },
  async created() {
    try {
      await (this as any).$dep.authUseCase.setupToken();
      await this.$store.dispatch("getUser");
      const { role } = this.$store.getters.user;
      const isPermission = ["ADMIN"].includes(role);

      if (isPermission) {
        this.$router.push({ name: "CompaniesPage" });
      } else {
        const items = await (this as any).$dep.companyUseCase.getCompanies();

        if (!items || items.length === 0) {
          await (this as any).$dep.authUseCase.clearToken();
          this.$router.push({ name: "AuthErrorPage", query: { type: "no_access" } });
          return;
        }

        const today = new Date().toISOString().slice(0, 10);
        const unexpired = items.filter((c: any) => !c.end_date || c.end_date >= today);

        if (unexpired.length === 0) {
          await (this as any).$dep.authUseCase.clearToken();
          const latestExpired = items.reduce(
            (latest: any, c: any) => (!latest || c.end_date > latest.end_date ? c : latest),
            null
          );
          this.$router.push({ name: "AuthErrorPage", query: { type: "expired", endDate: latestExpired.end_date } });
          return;
        }

        if (unexpired.length > 1) {
          this.$router.push({ name: "CompaniesPage" });
          return;
        }

        sessionStorage.setItem("company_id", unexpired[0].id);
        await this.getCompany();
        await this.getStructure();
        this.$router.push({ name: "CompanyPage", params: { id: unexpired[0].id } });
      }
    } catch (error) {
      this.$router.push({ name: "AuthLogoutRedirectPage" });
      (this as any).$dep.authUseCase.logout();
    }
  },
  methods: {
    ...mapActions(["getUser", "getCompany", "getStructure"]),
  },
});
